/* eslint-disable no-sequences */
import React, { useState, cloneElement, useEffect } from "react";
import axios from "axios/index";
import { API } from "../../../../utilities/api.config";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog/Dialog";
import { Close } from "@material-ui/icons";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import CancelIcon from "@material-ui/icons/Cancel";
import FormHelperText from "@material-ui/core/FormHelperText";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import {
  DateInput,
  isValid as DateValid,
} from "../../../../components/DateField";
import * as Yup from "yup";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@material-ui/core/Button/Button";
import { OpenInNew } from "@material-ui/icons";

import Slide from "@material-ui/core/Slide/Slide";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@material-ui/core/TextField";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  advisorChip: {
    color: theme.palette.primary.main,
  },
  nonEditableTextField: {
    color: theme.palette.grey[700],
    "&.MuiInputBase-formControl": {
      marginTop: 0,
    },
  },
  textField: {
    color: theme.palette.primary.main,
    "&.MuiInputBase-formControl": {
      marginTop: 0,
    },
  },
  nonEditableDateField: {
    color: "#515151",
    "&.MuiInputBase-formControl": {
      marginTop: 0,
      fontSize: "16px",
    },
  },
  dateField: {
    color: theme.palette.primary.main,
    "&.MuiInputBase-formControl": {
      marginTop: 0,
      fontSize: "16px",
    },
  },
  helperText: {},
  paper: {
    width: "100%",
    height: "80%",
    padding: 24,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      height: "100%",
      padding: 0,
    },
  },
  dialogContent: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "0px 24px",
    },
  },
  dialogActions: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "8px 20px 20px 20px",
    },
  },
  dialogTitle: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "16px 24px 0px 24px",
    },
  },
  stepperRoot: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "0px 24px 8px 24px",
    },
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  caption: {
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#000000",
  },
  repCodeBody: {
    fontSize: "18.25px",
    lineHeight: "22px",
    weight: 400,
    color: theme.palette.grey[600],
  },
  sectionHeading: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    marginBottom: 10,
    lineHeight: "28px",
    fontSize: 24,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 16,
      display: "inline-block",
    },
    color: theme.palette.grey[800],
  },
  label: {
    paddingTop: 6,
    paddingBottom: 7,
    fontSize: 20,
    lineHeight: "22px",
  },
  finraLink: {
    fontSize: 14,
    color: theme.palette.primary.main
  }
}));
const defaultValues = {
  bdRepCode: "",
  advisors: [],
};
const defaultAdvisor = {
  firstName: "",
  lastName: "",
  email: "",
  dateOfBirth: moment(new Date()).format("MM/DD/YYYY"),
  advisorCrdRef: "",
};
const addSplitRepCodeSchema = Yup.object().shape({
  bdRepCode: Yup.string().required(),
});

const advisorSchema = Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  email: Yup.string().email().required(),
  dateOfBirth: Yup.string().required(),
  advisorCrdRef: Yup.string().required(),
});
const addAdvisorSchema = Yup.object().shape({
  advisors: Yup.array().of(advisorSchema),
  bdRepCode: Yup.string().required(),
});

const AddSplitRepCodeModalContent = (props) => {
  const {
    user,
    editSplitRepCodeData,
    handleSaveSplitRepCode,
    open,
    onClose,
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  // set state
  const [data, setData] = useState(defaultValues);
  const [repCodeChecked, setRepCodeChecked] = useState(false);
  const [advisorChecked, setAdvisorChecked] = useState(false);

  const [relatedAdvisorsMessage, setRelatedAdvisorsMessage] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isAdvisorValid, setIsAdvisorValid] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const [advisor, setAdvisor] = useState(defaultAdvisor);

  const [showAdvisorHelper, setShowAdvisorHelper] = useState(false);

  // form validation
  const ValidateForm = () => {
    if (activeStep === 0) {
      if (addSplitRepCodeSchema.isValidSync(data)) {
        return setIsFormValid(true);
      }
      return setIsFormValid(false);
    }
    if (activeStep === 1) {
      if (addAdvisorSchema.isValidSync(data)) {
        return setIsFormValid(true);
      }
      return setIsFormValid(false);
    }
  };
  const ValidateAdvisor = () => {
    if (advisorSchema.isValidSync(advisor)) {
      return setIsAdvisorValid(true);
    }
    return setIsAdvisorValid(false);
  };

  useEffect(() => {
    ValidateForm();
  }, [data]);

  useEffect(() => {
    ValidateAdvisor();
    ValidateForm();
  }, [advisor, activeStep]);

  // add user as first advisor
  useEffect(() => {
    const relatedAdvisors =
      editSplitRepCodeData &&
      editSplitRepCodeData.associatedSplitRepCodes &&
      editSplitRepCodeData.associatedSplitRepCodes.map(
        (split) => split.user || undefined
      );

    const formatAdvisors =
      (relatedAdvisors &&
        relatedAdvisors.map((advisor) => {
          return {
            firstName: advisor.first_name,
            lastName: advisor.last_name,
            email: advisor.email,
            dateOfBirth: moment(advisor.birthdate).format("MM/DD/YYYY"),
            advisorCrdRef: advisor.advisorCrdRef,
          };
        })) ||
      [];

    if (open) {
      setData({
        ...data,
        ...editSplitRepCodeData,
        repCodeId: (editSplitRepCodeData && editSplitRepCodeData.id) || null,
        advisors: [
          {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            dateOfBirth: moment(user.birthdate).format("MM/DD/YYYY"),
            advisorCrdRef: user.advisorCrdRef,
          },
          ...(formatAdvisors || []),
        ],
      });

      const firstAdvsior =
        relatedAdvisors &&
        relatedAdvisors.find((advisor) => advisor.id !== user.id);
      if (relatedAdvisors) {
        setAdvisor({
          firstName: firstAdvsior.first_name,
          lastName: firstAdvsior.last_name,
          email: firstAdvsior.email,
          dateOfBirth: moment(firstAdvsior.birthdate).format("MM/DD/YYYY"),
          advisorCrdRef: firstAdvsior.advisorCrdRef,
        });
      }
    }
  }, [open]);

  const getCrd = (advisorCrdRef) => {
    axios
      .get(`${API.GET_USER_BY_CRD}/${advisorCrdRef}`, {
        headers: { Authorization: localStorage.getItem("wbiAuthToken") },
      })
      .then(
        (response) => (
          setAdvisor({
            ...advisor,
            firstName: response.data.user.firstName,
            lastName: response.data.user.lastName,
            email: response.data.user.email,
            dateOfBirth: moment(response.data.user.birthdate).format(
              "MM/DD/YYYY"
            ),
          }),
          setShowAdvisorHelper(false),
          setIsFormValid(true),
          setIsAdvisorValid(true),
          setAdvisorChecked(true)
        )
      )
      .catch(
        () => {
          setShowAdvisorHelper(true);
          setAdvisorChecked(true);
          setAdvisor({
            ...defaultAdvisor,
            advisorCrdRef
          });
        }
      );
  };

  const getRelatedAdvisors = (repCode) => {
    axios
      .post(
        `${API.SEARCH_RELATED_ADVISORS}`,
        { repCode, brokerDealerId: user.brokerDealer.id },
        {
          headers: { Authorization: localStorage.getItem("wbiAuthToken") },
        }
      )
      .then((response) => {
        setRelatedAdvisorsMessage("");
        const firstAdvisor = response.data.advisors.find(
          (advisor) => advisor.id !== user.id
        );
        const advisors = response.data.advisors.map((advisor) => {
          return {
            firstName: advisor.first_name,
            lastName: advisor.last_name,
            email: advisor.email,
            dateOfBirth: moment(advisor.birthdate).format("MM/DD/YYYY"),
            advisorCrdRef: advisor.advisorCrdRef,
          };
        });

        setData({ ...data, advisors: [...advisors] });
        // update first advisor
        setAdvisor({
          advisorCrdRef: firstAdvisor.advisorCrdRef,
          firstName: firstAdvisor.first_name,
          lastName: firstAdvisor.last_name,
          email: firstAdvisor.email,
          dateOfBirth: moment(firstAdvisor.birthdate).format("MM/DD/YYYY"),
        });
        setShowAdvisorHelper(false);
        setIsAdvisorValid(true);
        setIsFormValid(true);
        setRepCodeChecked(true);
      })
      .catch((err) => {
        setRepCodeChecked(true);

        if (err.response.data !== undefined) {
          setRelatedAdvisorsMessage(err.response.data.error);
        }
      });
  };
  // form handlers
  const handleResetAdvisor = () => {
    setAdvisor(defaultAdvisor);
    setShowAdvisorHelper(false);
  };
  const handleAddAdvisor = (advisor) => {
    const { advisorCrdRef } = advisor;
    // update existing advisor
    if (data.advisors.find((v) => v.advisorCrdRef === advisorCrdRef)) {
      const updateArray = data.advisors.filter(
        (advisor) => advisor.advisorCrdRef !== advisorCrdRef
      );
      return (
        setData({ ...data, advisors: [...updateArray, advisor] }),
        handleResetAdvisor()
      );
    } // add new advisor
    else {
      return (
        setData({ ...data, advisors: [...data.advisors, advisor] }),
        handleResetAdvisor()
      );
    }
  };

  const saveSplitRepCode = (e) => {
    handleSaveSplitRepCode({ ...data, isSplit: true });
    handleCloseModal();
  };

  const handleCloseModal = () => onClose();

  const handleRemoveAdvisor = (advisorCrdRef) => {
    const newAdvisors = data.advisors.filter(
      (advisor) => advisor.advisorCrdRef !== advisorCrdRef
    );
    setData({ ...data, advisors: newAdvisors });
  };

  return (
    <React.Fragment>
      <DialogTitle
        disableTypography
        id="add-split-rep-code-modal-title"
        classes={{ root: classes.dialogTitle }}
      >
        <Typography variant={"h4"} className={classes.sectionHeading}>
          Add Split Rep Code
        </Typography>
        <IconButton
          className={classes.modalCloseBtn}
          aria-label="Close"
          onClick={onClose}
        >
          <Close color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {/* step container */}
        <Grid container>
          <Grid item xs={12}>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              classes={{ root: classes.stepperRoot }}
            >
              <Step completed={activeStep > 0}>
                <StepLabel>
                  <Typography variant="body1">Split Rep Code</Typography>
                </StepLabel>
              </Step>
              <Step completed={activeStep > 1}>
                <StepLabel>
                  <Typography variant="body1">Add Advisors</Typography>
                </StepLabel>
              </Step>
              <Step completed={activeStep > 2}>
                <StepLabel>
                  <Typography variant="body1">Done</Typography>
                </StepLabel>
              </Step>
            </Stepper>
          </Grid>
        </Grid>

        {/* form content */}

        {activeStep === 0 && (
          <React.Fragment>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>
                  Split BD Rep Code
                </Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  fullWidth
                  helperText={relatedAdvisorsMessage}
                  value={data.bdRepCode}
                  onChange={(e) =>
                    setData({
                      ...data,
                      bdRepCode: e.target.value.toUpperCase(),
                    })
                  }
                  InputProps={{
                    classes: { root: classes.textField },
                    inputProps: {
                      "aria-label": "BD Rep Code",
                    },
                    endAdornment: (
                      <IconButton
                        size={"small"}
                        aria-label={"search"}
                        onClick={() => getRelatedAdvisors(data.bdRepCode)}
                      >
                        <SearchIcon
                          style={{
                            color: theme.palette.secondary.mediumGray,
                          }}
                        />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {activeStep === 1 && (
          <React.Fragment>
            <Grid item xs={12} container style={{ display: "inline-block" }}>
              <Typography display="block">
                Don’t know the advisor’s CRD Number? Look it up at BrokerCheck
              </Typography>

              <Typography
                display="block"
                style={{ textDecoration: "underline" }}
              >
                brokercheck.finra.org
                <a
                  href="https://brokercheck.finra.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OpenInNew className={classes.finraLink} />
                </a>
              </Typography>
            </Grid>

            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>CRD Number</Typography>
              </Grid>
              <Grid item xs={11} sm={7}>
                <TextField
                  value={advisor.advisorCrdRef}
                  fullWidth
                  type="number"
                  onChange={(e) =>
                    setAdvisor({
                      ...advisor,
                      advisorCrdRef: e.target.value,
                    })
                  }
                  InputProps={{
                    inputProps: {
                      "aria-label": "CRD Number",
                    },
                    classes: { root: classes.textField },
                    endAdornment: (
                      <IconButton
                        size={"small"}
                        aria-label={"search"}
                        onClick={() => getCrd(advisor.advisorCrdRef)}
                      >
                        <SearchIcon
                          style={{ color: theme.palette.grey[600] }}
                        />
                      </IconButton>
                    ),
                  }}
                />
                {showAdvisorHelper && (
                  <FormHelperText error>
                    <WarningIcon style={{
                        color: theme.palette.secondary.main,
                        display: "inline",
                        alignSelf: "center",
                        position: "relative",
                        marginRight: "4px",
                        top: "0.25em",
                      }} />

                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: 700,
                        color: "#515151",
                        display: "inline",
                      }}
                    >
                      Advisor not found in Cy. Please enter their
                      details and we’ll notify you when you can start using
                      this split rep code.
                    </Typography>
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                item
                xs={1}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CancelIcon
                  style={{ color: theme.palette.grey[600] }}
                  onClick={() => handleResetAdvisor()}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>First Name</Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  required
                  disabled={!showAdvisorHelper}
                  value={advisor.firstName}
                  fullWidth
                  onChange={(e) =>
                    setAdvisor({ ...advisor, firstName: e.target.value })
                  }
                  placeholder="First Name"
                  InputProps={{
                    classes: {
                      root: showAdvisorHelper
                        ? classes.textField
                        : classes.nonEditableTextField,
                    },
                    inputProps: {
                      "aria-label": "First Name",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>Last Name</Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  required
                  disabled={!showAdvisorHelper}
                  value={advisor.lastName}
                  onChange={(e) =>
                    setAdvisor({ ...advisor, lastName: e.target.value })
                  }
                  fullWidth
                  placeholder="Last Name"
                  InputProps={{
                    classes: {
                      root: showAdvisorHelper
                        ? classes.textField
                        : classes.nonEditableTextField,
                    },
                    inputProps: {
                      "aria-label": "Last Name",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>Email</Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  required
                  disabled={!showAdvisorHelper}
                  type="email"
                  value={advisor.email}
                  onChange={(e) =>
                    setAdvisor({ ...advisor, email: e.target.value })
                  }
                  error={!Yup.string().email().isValidSync(advisor.email)}
                  helperText={
                    !Yup.string().email().isValidSync(advisor.email) &&
                    "Please Enter a Valid Email Address"
                  }
                  fullWidth
                  placeholder="Email"
                  InputProps={{
                    classes: {
                      root: showAdvisorHelper
                        ? classes.textField
                        : classes.nonEditableTextField,
                    },
                    inputProps: {
                      "aria-label": "Email",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={4}>
                <Typography className={classes.label}>
                  Date of Birth
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  required
                  disabled={!showAdvisorHelper}
                  error={!DateValid(advisor.dateOfBirth)}
                  helperText={
                    !DateValid(advisor.dateOfBirth) &&
                    "Please enter a valid date"
                  }
                  InputProps={{
                    "aria-label": `Client Date of Birth`,
                    inputComponent: DateInput,
                    value: advisor.dateOfBirth,
                    onChange: (e) =>
                      setAdvisor({
                        ...advisor,
                        dateOfBirth: e.target.value,
                      }),
                    classes: {
                      root: showAdvisorHelper
                        ? classes.dateField
                        : classes.nonEditableDateField,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} container>
                <Grid item xs={12}>
                  <Typography className={classes.caption}>
                    Advisors
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {/* render advisor array */}
                  {data.advisors.map((advisor) => (
                    <Chip
                      onClick={() => (
                        setActiveStep(activeStep - 1),
                        setAdvisor(
                          data.advisors.filter((v) => {
                            return v.advisorCrdRef === advisor.advisorCrdRef;
                          })[0]
                        )
                      )}
                      key={advisor.advisorCrdRef}
                      label={
                        <React.Fragment>
                          <Typography
                            display="inline"
                            className={
                              user.advisorCrdRef === advisor.advisorCrdRef
                                ? undefined
                                : classes.advisorChip
                            }
                            style={{
                              fontWeight:
                                user.advisorCrdRef === advisor.advisorCrdRef
                                  ? undefined
                                  : 700,
                            }}
                          >
                            {advisor.firstName} {advisor.lastName}
                          </Typography>{" "}
                          {user.advisorCrdRef !== advisor.advisorCrdRef && (
                            <Typography
                              display="inline"
                              className={classes.advisorChip}
                            >
                              ({advisor.advisorCrdRef})
                            </Typography>
                          )}
                        </React.Fragment>
                      }
                      style={{ margin: 6 }}
                      onDelete={
                        user.advisorCrdRef === advisor.advisorCrdRef
                          ? undefined
                          : () => handleRemoveAdvisor(advisor.advisorCrdRef)
                      }
                    />
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {/* review  */}
        {activeStep === 2 && (
          <React.Fragment>
            <Grid item xs={12} container>
              <Grid item xs={12} sm={2}>
                <Typography className={classes.caption}>
                  BD Rep Code
                </Typography>
                <Typography className={classes.repCodeBody} gutterBottom>
                  {data.bdRepCode}
                </Typography>
              </Grid>
              {data.CustodianId === 7 && (
                <Grid item xs={12} sm={2}>
                  <Typography className={classes.caption}>
                    PAS Rep Code
                  </Typography>
                  <Typography className={classes.repCodeBody} gutterBottom>
                    {data.custodialRepCode}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} sm={2}>
                <Typography className={classes.caption}>
                  CRD Number
                </Typography>
                <Typography className={classes.repCodeBody} gutterBottom>
                  {user.advisorCrdRef}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={1}>
              <Grid item xs={12}>
                <Typography className={classes.caption}>Advisors</Typography>
              </Grid>
              <Grid item xs={12}>
                {/* render advisor array */}
                {data.advisors.map((advisor) => (
                  <Chip
                    onClick={() => (
                      setActiveStep(activeStep - 1),
                      setAdvisor(
                        data.advisors.filter((v) => {
                          return v.advisorCrdRef === advisor.advisorCrdRef;
                        })[0]
                      )
                    )}
                    key={advisor.advisorCrdRef}
                    label={
                      <React.Fragment>
                        <Typography
                          display="inline"
                          className={
                            user.advisorCrdRef === advisor.advisorCrdRef
                              ? undefined
                              : classes.advisorChip
                          }
                          style={{
                            fontWeight:
                              user.advisorCrdRef === advisor.advisorCrdRef
                                ? undefined
                                : 700,
                          }}
                        >
                          {advisor.firstName} {advisor.lastName}
                        </Typography>{" "}
                        {user.advisorCrdRef !== advisor.advisorCrdRef && (
                          <Typography
                            display="inline"
                            className={classes.advisorChip}
                          >
                            ({advisor.advisorCrdRef})
                          </Typography>
                        )}
                      </React.Fragment>
                    }
                    style={{ margin: 6 }}
                    onDelete={
                      user.advisorCrdRef === advisor.advisorCrdRef
                        ? undefined
                        : () => handleRemoveAdvisor(advisor.advisorCrdRef)
                    }
                  />
                ))}
              </Grid>
            </Grid>
          </React.Fragment>
        )}
      </DialogContent>
      {/*actions is a flex container */}
      <DialogActions classes={{ root: classes.DialogActions }}>
        {activeStep === 0 && (
          <React.Fragment>
            {repCodeChecked ? (
              <Button
                disabled={!isFormValid}
                variant="contained"
                color="primary"
                onClick={() => (
                  setActiveStep(activeStep + 1),
                  setIsFormValid(false),
                  setRepCodeChecked(false)
                )}
              >
                Add Advisor
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={() => getRelatedAdvisors(data.bdRepCode)}
              >
                Find Advisors
              </Button>
            )}
          </React.Fragment>
        )}
        {activeStep > 0 && (
          <React.Fragment>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => (
                setActiveStep(activeStep - 1),
                setShowAdvisorHelper(false),
                setAdvisorChecked(false),
                handleResetAdvisor()
              )}
            >
              Back
            </Button>
            <Button
              disabled={
                activeStep === 2 ? false : !(isFormValid && isAdvisorValid)
              }
              variant="outlined"
              color="primary"
              onClick={(e) =>
                activeStep === 2
                  ? (setActiveStep(activeStep - 1),
                    setIsFormValid(false),
                    handleResetAdvisor())
                  : (handleAddAdvisor(advisor), setIsFormValid(false))
              }
            >
              Add Advisor
            </Button>
            {activeStep === 2 ? (
              <Button
                variant="contained"
                color="primary"
                disabled={!isFormValid}
                onClick={() => saveSplitRepCode()}
              >
                Done
              </Button>
            ) : data.advisors.length >= 2 ? (
              <Button
                variant="contained"
                color="primary"
                disabled={!isFormValid}
                onClick={() => (
                  isAdvisorValid ? handleAddAdvisor(advisor) : undefined,
                  setActiveStep(activeStep + 1),
                  setIsFormValid(activeStep === 1 ? true : false)
                )}
              >
                Continue
              </Button>
            ) : advisorChecked ? (
              <Button
                variant="contained"
                color="primary"
                disabled={!isFormValid}
                onClick={() => (
                  isAdvisorValid ? handleAddAdvisor(advisor) : undefined,
                  setActiveStep(activeStep + 1),
                  setIsFormValid(activeStep === 1 ? true : false)
                )}
              >
                Continue
              </Button>
            ) : (
              <Button
                disabled={advisor.advisorCrdRef === ""}
                variant="contained"
                color="primary"
                onClick={() => getCrd(advisor.advisorCrdRef)}
              >
                Search CRD
              </Button>
            )}
          </React.Fragment>
        )}
      </DialogActions>
    </React.Fragment>
  );
};

AddSplitRepCodeModalContent.propTypes = {
  user: PropTypes.object.isRequired,
  editSplitRepCodeData: PropTypes.object,
  handleSaveSplitRepCode: PropTypes.func.isRequired,
};

export default function AddSplitRepCodeModal({
  dialogAnchorComponent,
  user,
  editSplitRepCodeData,
  handleSaveSplitRepCode,
}) {

  const [open, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <React.Fragment>
      {/** I am going to change it, but what the **** is this :\ */}
      {cloneElement(dialogAnchorComponent, { onClick: () => setOpen(true) })}
      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={() => setOpen(false)}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        maxWidth={"md"}
        classes={{ paper: classes.paper }}
        aria-labelledby="add-split-rep-code-modal-title"
        aria-describedby="add-split-rep-code-modal-description"
      >
        { 
          open &&
          <AddSplitRepCodeModalContent
            open={open}
            user={user}
            editSplitRepCodeData={editSplitRepCodeData}
            handleSaveSplitRepCode={handleSaveSplitRepCode}
            onClose={() => setOpen(false)}
          />
        }
      </Dialog>
    </React.Fragment>
  )
}




// WEBPACK FOOTER //
// ./src/containers/UserRepCodes/components/AddSplitRepCodeModal/index.jsx